export const VN_SET_CONFIGURATION = 'VN_SET_CONFIGURATION'
